import { SidebarProvider } from '#app/components/ui/sidebar'
import { AppSidebar } from './_appSidebar'
import { useOptionalUser } from './utils/user'

export default function Layout({ children }: { children: React.ReactNode }) {
	const user = useOptionalUser()
	return (
		<SidebarProvider defaultOpen={false}>
			{user && <AppSidebar />}
			{children}
		</SidebarProvider>
	)
}
